import * as i0 from "@angular/core";
var SpinnerService = /** @class */ (function () {
    function SpinnerService() {
        this.showSpinner = false;
    }
    SpinnerService.prototype.show = function () {
        this.showSpinner = true;
    };
    SpinnerService.prototype.hide = function () {
        this.showSpinner = false;
    };
    SpinnerService.ngInjectableDef = i0.defineInjectable({ factory: function SpinnerService_Factory() { return new SpinnerService(); }, token: SpinnerService, providedIn: "root" });
    return SpinnerService;
}());
export { SpinnerService };
